




import { Component, Inject, Prop, Mixins } from "vue-property-decorator";
import {
  IInvoiceProvider,
  IInvoiceProviderMethods
} from "@/models/providers/invoice";
import ExternalAuthMixin from "@/components/app/global/payments/externalAuthMixin.vue";

@Component
export default class OpenInvoiceModal extends Mixins(ExternalAuthMixin) {
  // Inject
  @Inject({ from: "invoiceProvider" })
  public readonly $invoiceProvider!: () => IInvoiceProvider;

  @Inject({ from: "invoiceProviderMethods" })
  public readonly $invoiceMethods!: IInvoiceProviderMethods;

  @Prop({ required: true })
  public readonly redirectToRouteName!: string;

  public openModal() {
    this.checkExternalAuthQueryParams();
    this.$invoiceMethods.pay({
      props: {
        preselectedStoredPaymentMethodId: this.paymentDetailIdFromExternalAuth,
        preselectedShowPendingPayment: this.showPendingPaymentQueryParam
      }
    });

    this.$router.replace({
      ...this.$route,
      name: this.redirectToRouteName
    });
  }

  public get $invoice() {
    return this.$invoiceProvider();
  }
}
